import { useEffect } from 'react';

import { organizationsStore } from '../../../stores/dictionaryStores/organizationsStore';
import { reportingTreeStore } from '../../../stores/reportingTreeStore';

// Проверяем какая организация должна быть выбрана. Если пришли из другого роута для раскрытия дерева (expandedTreeFromAnotherRouter) подставляем оргу из localStorage.
// Если ее нет берем из sessionStorage. Если он пуст - ставим по умолчанию головную организацию.
// Сделано так, чтобы уменьшить повторные запросы и рендеры.
export const useCheckOrganization = (): void => {
  const { organizations } = organizationsStore;
  const { setOrganizationCode } = reportingTreeStore;

  useEffect(() => {
    if (organizations.length) {
      let orgCode: string | null = null;

      const config = sessionStorage.getItem('reportingTreeConfig');
      const parseConfig = config ? JSON.parse(config) : null;

      if (parseConfig && parseConfig.organizationCode) {
        orgCode = parseConfig.organizationCode;
      }

      const storage = localStorage.getItem('expandedTreeFromAnotherRouter');
      const parseStorage = storage ? JSON.parse(storage) : null;

      if (parseStorage && parseStorage.organizationCode) {
        orgCode = parseStorage.organizationCode;
      }

      if (!orgCode) {
        const headOrganization = organizations.find((org) => org.head);
        if (headOrganization && headOrganization.code) {
          orgCode = headOrganization.code;
        }
      }

      setOrganizationCode(orgCode);
    }
  }, [organizations, setOrganizationCode]);
};
